jQuery(document).ready(function () {
    jQuery(document).on('change', 'form .variant-selector', function () {
        var $this = this;
        var variantprice = jQuery($this).find('option:selected').attr('data-variant-price');
        console.log(':: selected :: variant-selector: ' + variantprice);
        jQuery($this).closest('.product-card').find('.current_price span.money').html(variantprice);
    });
});



jQuery(document).ready(function () {


    jQuery(document).on('click', 'section.popup .cmdclose', function () {
        //jQuery('.popup').fadeOut(200);
        setTimeout(function () {
            jQuery('.popup .popupcontent').removeClass('popup-anchored');
        }, 200);
    });

    jQuery(document).on('click', '.footer_menu a', function (evt) {
        console.log('pop!');
        evt.preventDefault();
        $this = this;

        jQuery('section.popup .fetched').html('');
        var loadingtimer;
        loadingtimer = setTimeout(function () {
            jQuery('section.popup .fetched').html('<p clas="loading-content">Loading...<p>');
        }, 1000);

        var href = jQuery($this).attr('href');
        if (href) {
            console.log(':: clicked ::' + href);
            // jQuery('section.popup .fetched').html('<iframe src="' + href + '?pop"></iframe>');
            var url = href;
            //API USAGE: https://help.shopify.com/en/api/reference/online-store/page#index
            // var handle = href;
            // handle = handle.replace('/pages/', '');
            // handle = handle.replace(/\//, '');
            // console.log(':: handle ::' + handle);
            // url = '/admin/api/2019-04/pages.json?handle=' + handle;
            jQuery.ajax({
                url: url,
                cache: true
            }).done(function (data) {
                if (data) {
                    clearTimeout(loadingtimer);
                    try {
                        var content = '';
                        // if (typeof data === 'string') { data = JSON.parse(data); }
                        // var title = data.pages[0].title;
                        // var body_html = data.pages[0].body_html;
                        var title = data.match(/\<h1[^\>]*\>[\s\S\n]*?\<\/h1\>/);
                        if (title == null) { title = ''; } else { title = title[0]; }
                        title = title.replace(/\<[^\>]*\>/g, '');
                        var body_html = data.match(/\<article[^\>]*\>[\s\S\n]*?\<\/article\>/);
                        if (body_html == null) { body_html = ''; } else { body_html = body_html[0]; }
                        content += '<h2 style="max-width: 69%; text-align: left;">' + title + '</h2>';
                        content += '<div class="body_html" style="height: 57vh; overflow: auto; margin:7vh 0 0; padding:10px;">' + body_html + '</div>';
                        jQuery('section.popup .fetched').html(content);
                    } catch (err) {
                        console.log('##### ERROR: ' + err.message);
                    }
                }
            });
        }
        jQuery('section.popup').fadeIn(300);
        setTimeout(function () {
            jQuery('.popup .popupcontent').addClass('popup-anchored');
        }, 100);
        return false;
    });

});


// jQuery(document).ready(function () {
//     jQuery('.product_thumbnail .was_price').hide();
//     jQuery('.shopify-product-form .selector-wrapper select').hide();
//     jQuery('.shopify-product-form select.variant-selector').show();
//     jQuery(document).on('change', '.product_thumbnail form .variant-selector', function () {
//         var $this = this;
//         var variantprice = jQuery($this).find('option:selected').attr('data-variant-price');
//         console.log(':: selected :: variant-selector: ' + variantprice);
//         jQuery($this).closest('.product_thumbnail').find('.sale span.money').html(variantprice);
//     });
// });



// jQuery(document).on('click', 'a.cart-button', function () {
//     ajaxSubmitCart(); 
// });


// var cart_button_timer;
// jQuery(document).on('click', 'a.cart-button', function () {
//     if (cart_button_timer) { clearTimeout(cart_button_timer); }
//     cart_button_timer = setTimeout(function () {
//         ajaxSubmitCart();
//       }, 1);
// });

// jQuery(document).ready(function () {
//     console.log('checkout status...');
//     var ckstatus_counter = 0;
//     setInterval(function () {
//         ckstatus_counter++;
//         var ckstatus = jQuery('section.checkoutstatus .updates');
//         var money = jQuery('#cart .mm-counter.price .money').text();
//         if (money) {
//             money = money.replace('$', '');
//             if (!isNaN(money)) {
//                 money = parseFloat(money);
//                 if (money > 0) {
//                     var ss = '';
//                     ss += '<h4>$' + money + '</h4>';
//                     ckstatus.html(ss);
//                 } else {
//                     ckstatus.html('');
//                 }
//             }
//         }
//         if (ckstatus_counter > 100) {
//             console.log('...');
//             ckstatus_counter = 0;
//         }
//     }, 1000);
// });


function dbx_refresh_cart_icon(data) {
    var cartitems = '';
    if (data.item_count != null) {
        cartitems = data.item_count;
    }
    if (jQuery('#CartCount span').length < 1) {
        jQuery('.site-header__cart').append(jQuery('<div id="CartCount" class="site-header__cart-count"><span>' + cartitems + '</span></div>'));
    }
    jQuery('#CartCount span').html(cartitems);
}

var dbx_upsell_script_called = false;
function dbx_upsell_script() {
    if (dbx_upsell_script_called) { return; }
    dbx_upsell_script_called = true;

    var an_upsell_is_visible = false;
    // var dbx_show_upsell_called=false;
    function dbx_show_upsell($this) {

        var $this_button = $this;
        // if(dbx_show_upsell_called){ return; }
        // dbx_show_upsell_called=true;
        // if(jQuery('#cart .cart_item').length<1){ return; }

        // var product = '{{ product.url }}';
        // var cartquery = jQuery('#cart ul.mm-listview').find('a[href*="{{ product.url }}"]');
        // if(cartquery.length>0){ 
        //   console.log('Product already in cart. Exiting...');
        //   return; 
        // }

        //NB: determine the trigger product ID (the target)
        if ($this_button != null) {
            var selected_product_dom = []; //NB: ARRAY NEEDED to verify whether the length is 0 or more
            if (selected_product_dom.length < 1) { selected_product_dom = jQuery($this_button).closest('.product-content'); }
            if (selected_product_dom.length < 1) { selected_product_dom = jQuery($this_button).closest('.product-single'); }
            if (selected_product_dom.length < 1) { selected_product_dom = jQuery($this_button).closest('.product-card'); }
            if (selected_product_dom.length < 1) { selected_product_dom = jQuery($this_button).closest('.product_thumbnail'); }

            var target_pid = null;
            if (target_pid == '') { target_pid = null; }
            if (isNaN(target_pid)) { target_pid = null; }

            if (target_pid == null) {
                //NB: the target product was not identified as yet
                if (target_pid == null) { target_pid = jQuery(selected_product_dom).find('input[name="id"]').val(); }
                if (target_pid == null) { target_pid = jQuery(selected_product_dom).find('select[name="id"]').val(); }
                if (target_pid == null) { target_pid = ''; }
                target_pid = target_pid.replace(/\D/g, '');
            }
        }
        console.log('* trigger product ID (the target): ' + target_pid);

        var upsell_to_show = jQuery('.upsell-product-section .upsell.watchlist-unspecified'); //NB: all watchlist-unspecified
        var upsell_target_identified = false;
        jQuery('.upsell').each(function(){
            var $this = this;
            if(jQuery($this).attr('class').indexOf(target_pid)>-1){
                //NB: targeted upsell triggered
                upsell_to_show = $this;
                upsell_target_identified = true;
            }
        });

        var slide_down_durration = 200;
        if(an_upsell_is_visible){
            jQuery('.upsell-product-section .upsell:not(.watchlist-unspecified)').fadeTo(1, 0);
            slide_down_durration = 1;
        }

        jQuery('body').addClass('upsell-active');

        setTimeout(function () {
            jQuery(upsell_to_show).slideDown(slide_down_durration, function () {
                jQuery(upsell_to_show).fadeTo(1, 1);
                if (upsell_target_identified) {
                    jQuery('.upsell-product-section .upsell.watchlist-unspecified').hide();
                } else {
                    jQuery('.upsell-product-section .upsell:not(.watchlist-unspecified)').hide();
                }

                an_upsell_is_visible = true;
            });
          
          
          	//NB: time when to slide.. in case of many upsells, need to do this just once!
            setTimeout(function(){
              var upsellScrollOffset = 20;
              if (jQuery(window).width() > 600) {
                upsellScrollOffset = 20;
              }
              //jQuery('.upsell-product-section').css({'min-height':'300px'});
              jQuery("html, body").animate({ scrollTop: jQuery('.upsell-product-section').offset().top - upsellScrollOffset }, 700);
            },1);
          
        }, 100);

        //jQuery('.row.faq_width').css('padding-top', '100px');

    }
    function dbx_clear_cart($callback) {
        jQuery.ajax({
            type: "POST",
            url: '/cart/clear.js',
            dataType: "json",
            cache: false,
            success: function (data) {
                console.log(".......... cart cleared! ");
                if ($callback) {
                    console.log(".......... calling back! ");
                    $callback();
                }
            }
        });
    }
    function dbx_update_cart($this, $opts, $callback) {
        //jQuery.post('/cart/clear.js');

        if ($opts == null) { $opts = {}; }
        if ($opts.action == null) { $opts.action = 'add'; }
        if ($opts.quantity == null) { $opts.quantity = 1; }

        var product_form = jQuery($this).closest('form.shopify-product-form');
        if (product_form) {
            var product_id = jQuery(product_form).find('input[name="id"]').val();
            if (product_id == null) { product_id = jQuery(product_form).find('select[name="id"]').val(); }
            console.log('*** ' + $opts.action + ' *** product id: ' + product_id);
            jQuery.ajax({
                type: "POST",
                url: '/cart/' + $opts.action + '.js',
                dataType: "json",
                cache: false,
                data: {
                    quantity: $opts.quantity,
                    id: product_id,
                },
                success: function (data) {
                    console.log(".......... cart updated");
                    console.log(data);
                    dbx_refresh_cart_icon(data)
                    if ($callback) {
                        console.log(".......... calling back! ");
                        $callback();
                    }
                }
            });
        }
    }

    function dbx_update_cart_status() {
        jQuery.getJSON('/cart.js', function (data) {
            console.log(data);
            if (data) {
                var price = data.total_price;
                if (price) {
                    price = price.toString();
                    price = price.trim();
                    price = '$' + price.replace(/(\d\d)$/, '.$1')
                    jQuery('.upsell-checkout-tab .totalprice').html('<b>TOTAL: ' + price + '</b>');
                    dbx_refresh_cart_icon(data);
                }
            }
        });
    }

    function dbx_init_upsell_quantity($this_upsell, quantity) { //NB: $this_upsell is the .upsell
        if (quantity == null) { quantity = 1; }
        var qtyobj = jQuery($this_upsell).find('input[name="quantity"]');
        qtyobj.val(quantity);
        var quantityObjs = jQuery($this_upsell).find('.shopify-payment-quantity');
        quantityObjs.fadeIn(300);
        jQuery($this_upsell).find('.upsell-payment-button').hide(); //NB: if showing quantityObjs then hide the default buy button
    }
    function dbx_reset_upsell_quantity($this_upsell, with_cart_reset) { //NB: $this_upsell is the .upsell
        if (with_cart_reset == null) { with_cart_reset = true; }
        var x = $this_upsell;
        if (with_cart_reset) {
            x = '.upsell'
        }
        jQuery(x).find('.upsell-payment-button').html('Add This');
        var qtyobj = jQuery(x).find('input[name="quantity"]');
        qtyobj.val(0);
        jQuery(x).find('.shopify-payment-quantity').fadeOut(300, function () {
            jQuery(x).find('.upsell-payment-button').fadeIn(300);
        });
      }
    function dbx_update_upsell_quantity($this_button) {
        console.log(':: click :: changing quantity ::');
        var $this_upsell = jQuery($this_button).closest('.upsell');
        var qtyobj = jQuery($this_upsell).find('input[name="quantity"]');
        if (isNaN(parseInt(qtyobj.val()))) {
            return;
        }
        if (jQuery($this_button).hasClass('plusbtn')) {
            qtyobj.val(parseInt(qtyobj.val()) + 1);
        } else if (jQuery($this_button).hasClass('minusbtn')) {
            qtyobj.val(parseInt(qtyobj.val()) - 1);
            if (qtyobj.val() < 1) {
                dbx_reset_upsell_quantity($this_upsell, false);
            }
        }
        var $opts = {
            'action': 'change', //NB: this is to change 1 item at a time... optionally check out update ---- jQuery.post('/cart/update.js', {updates: {794864053: 2, 794864233: 3}});
            'quantity': qtyobj.val()
        };
        dbx_update_cart($this_button, $opts, function () {
            dbx_update_cart_status();
        });
    }

    jQuery(document).ready(function () {
        console.log('^^^^^^^^^^ init upsell ^^^^^^^^^^');

        spf_display_checkout_tab(false);
        dbx_update_cart_status();

        jQuery('form.shopify-product-form .purchase-details').hide();
        jQuery('form.shopify-product-form').append('<button type="button" class="shopify-payment-button__button" style="display: inline-block; width: initial;">Buy It Now</button>');
        jQuery('.featured-collection-section .shopify-payment-button__button, button.action_button.add_to_cart').addClass('intercet-payment-button');
        jQuery(document).on('click', '.intercet-payment-button', function (evt) {
            evt.preventDefault();
            var $this = this;
            console.log(':: click :: upsell requested ::');
          
            
            spf_display_checkout_tab();

          
          

            var price = jQuery($this).closest('.product-card').find('.pricing .money');
            if (price.length > 0) {
                jQuery('.upsell-checkout-tab .totalprice').html('<b>TOTAL: ' + price.html() + '</b>');
            }

            jQuery('.product-card').removeClass('product-card-selected');
            jQuery($this).closest('.product-card').addClass('product-card-selected');

            setTimeout(function () {
                dbx_show_upsell($this);
                dbx_clear_cart(function () {
                    dbx_update_cart($this);
                    dbx_reset_upsell_quantity();
                });
            }, 1);

            //position the checkout button .. this should be locked at bottom if Buy it Now is pressed.
            /////////////////////////////////////////////////////////////////
            redesignCheckoutFooter(false);

            return false;
        });
        jQuery('.upsell-product-section .shopify-payment-button__button').html('Add This');
//       var pixelscrollcount = 5000;
        jQuery(document).on('click', '.upsell-product-section .shopify-payment-button__button', function (evt) {
            evt.preventDefault();
            var $this_button = this;
            var $this_upsell = jQuery($this_button).closest('.upsell');
            jQuery($this_button).addClass('upsell-payment-button');
            var quantityOpts = null;
            spf_display_checkout_tab();
            
            console.log(':: click :: accepting upsell product ::');
            var $opts = {
                'action': 'add',
                'quantity': 1
            };
            dbx_update_cart($this_button, $opts, function () {
                dbx_update_cart_status();
                jQuery($this_button).html('Added');
                jQuery($this_button).delay(300).fadeOut(300, function () {
                    quantityOpts = jQuery($this_upsell).find('.shopify-payment-quantity');
                    if (quantityOpts.length > 0) {
                        dbx_init_upsell_quantity($this_upsell);
                        if (jQuery($this_upsell).find('form.shopify-product-form .shopify-payment-quantity').length < 1) { //NB: just for a visual, move to form area
                            var product_form = jQuery($this_upsell).find('form.shopify-product-form');
                            jQuery(product_form).prepend(quantityOpts);
                        }
                        quantityOpts.fadeIn(300);
                    } else {
                        location.href = '/checkout/';
                    }
                });
              
              
              
//   'tis is' + jQuery('div.featured-collection-section').closest('div.featured-collection-section').next().find('div.featured-collection-section').attr("class") );
              
            });
       

        });
        jQuery(document).on('click', '.upsell-product-section .quantitybtn', function (evt) {
            evt.preventDefault();
            var $this = this;
            dbx_update_upsell_quantity($this);
            return false;
        });
        jQuery(document).on('change', '.upsell-product-section input[name="quantity"]', function (evt) {
            evt.preventDefault();
            var $this = this;
            dbx_update_upsell_quantity($this);
            return false;
        });
        return false;
    });
}









jQuery(document).ready(function () {
    jQuery('.upsell-checkout-tab button').removeAttr('onclick');
    // jQuery('#createcheckout1').hide();
  
  	jQuery('div#shopify-section-1558563650288').addClass('dc-item-display');
  
 	jQuery('div#shopify-section-1557735095130').addClass('dc-item-display');  //FAQs container
    jQuery('div#shopify-section-1558563650288').addClass('dc-item-display');  //payment logos
  	jQuery('.footer_menu1').addClass('dc-item-opacity'); 
  	jQuery('.site-footer').addClass('dc-item-display'); 
  	jQuery('.footer').addClass('dc-item-display');
  	jQuery('#shopify-section-footer .credits').addClass('dc-item-display');
  
  
    jQuery(document).on('click', '.upsell button', function () { redesignCheckoutFooter(false) });
});
jQuery(document).on('click', '.upsell-checkout-tab button, #checkout', function (evt) {
    console.log('......................... directcart!');
    evt.preventDefault();
    $this = this;

    if (jQuery($this).html() == 'Continue') {

        jQuery("#createcheckout1").trigger("click");

    } else {
        jQuery('.directcart-section').slideDown();

        // jQuery('.upsell-checkout-tab button').attr('onclick', 'location.href="/checkout/";');
        jQuery($this).html('Continue');
        // jQuery('.upsell-checkout-tab button').fadeOut(300);


        var DCScrollOffset = 20;
        if (jQuery(window).width() > 600) {
            DCScrollOffset = 200;
        }
        //jQuery("html, body").animate({ scrollTop: jQuery($this).offset().top }, 700);
        //jQuery("html, body").animate({ scrollTop: jQuery(".directcart.container").offset().top - DCScrollOffset }, 700);
        jQuery("html, body").animate({ scrollTop: jQuery(".directcart.container").offset().top }, 700);


        //jQuery('.row.faq_width').css('padding-top', '100px');

        /////////////////////////////////////////////////////////////////
        redesignCheckoutFooter(true);
    }


    return false;
});



jQuery(document).ready(function () {
    console.log('***** ***** CART ***** *****');
    function spf_request_cart_data(callback) {
        var buster = encodeURIComponent((new Date()).toString().replace(/\D/g, ''));
        jQuery.getJSON('/cart.js?' + buster, function (data) {
            console.log(data);
            if (data) {
                spf_current_cart = data;
                if (callback) {
                    console.log(".......... calling back! ");
                    callback(data);
                }
            }
        }).fail(function (jqxhr, textStatus, error) {
            var err = textStatus + ", " + error;
            console.log("Request cart data failed: " + err);
            if (callback) {
                console.log(".......... calling back! ");
                callback();
            }
        });
    }
    jQuery(document).on('click', '.add_to_cart', function () {
        console.log(':: add_to_cart ::');
        setTimeout(function () {
            spf_request_cart_data(function (data) {
                if (data != null) {
                    dbx_refresh_cart_icon(data);
                }
            });
        }, 1000);
    });
    jQuery(document).on('click', '.product-card button.shopify-payment-button__button', function () {
        var $this = this;
        if (jQuery($this).parent().find('btnmsg').length < 1) {
            jQuery($this).parent().append('<span class="btnmsg"></span>');
        }
        jQuery($this).parent().find('.btnmsg').html('<a style="position: absolute; width: 100%; padding: 3px;" href="/cart/">View Cart</a>');
    });
});






jQuery(document).off('click', '#checkout').on('click', '#checkout', function (evt) {
    console.log('......................... directcart!');
    evt.preventDefault();

    jQuery('#createcheckout1').css({ 'pointer-events': 'none' });
    jQuery('.upsell-checkout-tab button').html('Continue');
    spf_display_checkout_tab();

});



function spf_display_checkout_tab(shownow) {
    if (shownow == null) { shownow = true; }
    if (jQuery('.checkout-tab').length < 1 && jQuery('.upsell-checkout-tab').length < 1) {
        var checkout_tab = '<div class="checkout-tab upsell-checkout-tab directcart-checkout-tab" style="display:none; position: fixed; z-index: 999; left: 0; bottom: 0; padding: 10px; border-top: 1px solid #000000; background: #ffffff; width: 100%; text-align: center;"> <div class="inside"> <span class="cell"><span class="totalprice"></span><span class="itemcount" style="margin-right:10px;"></span></span> <span class="cell"><button class="btn checkout-btn" onclick="location.href=\'/checkout/\';">CHECKOUT</button></span> </div> </div>';
        jQuery('body').append(checkout_tab);
    }
    if(shownow){
        jQuery('.checkout-tab').fadeIn();
        jQuery('body').addClass('checkout-tab-active');
    }
    if (jQuery('.directcart').length > 0) {

        jQuery('.checkout-tab .checkout-btn').removeAttr('onclick');

    }
}





/**************************************************************************************/
jQuery(document).on('click', '.site-nav--has-dropdown', function(evt){
	var $this = this;
	if(jQuery($this).hasClass('activated')){
		jQuery($this).removeClass('activated')
    }else{
		jQuery($this).addClass('activated')
    }
});